import React from 'react';
import MegatelLandingPage from './pages/MegatelLandingPage';
import MeadowsLandingPage from './pages/MeadowsLandingPage';
import OptDigitalLandingPage from './pages/OptDigitalLandingPage';
import AdminDashboard from './pages/AdminDashboard';
import PortfolioApp from './pages/PortfolioApp';
import DynamicProposalPage from './pages/DynamicProposalPage';
import ToastStrategyPage from './pages/ToastStrategyPage';
import LilysDeckPage from './pages/LilysDeckPage';
import './App.css';

// Redirect www to non-www for SEO (canonical URL enforcement)
if (typeof window !== 'undefined' && window.location.hostname.startsWith('www.')) {
  window.location.href = window.location.href.replace('www.', '');
}

const pathname = typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') : '';
const isMegatelPage = pathname === '/megatel';
const isAdminPage = pathname === '/admin';
const isMeadowsPage = pathname === '/meadows';
const isOptDigitalPage = pathname === '/optdigital';
const isToastStrategyPage = pathname === '/toast-strategy';
const isLilysPage = pathname.toLowerCase() === '/lilys';
const proposalMatch = pathname.match(/^\/proposals\/([a-zA-Z0-9_-]+)$/);

function App() {
  if (isAdminPage) return <AdminDashboard />;
  if (isMegatelPage) return <MegatelLandingPage />;
  if (isMeadowsPage) return <MeadowsLandingPage />;
  if (isOptDigitalPage) return <OptDigitalLandingPage />;
  if (isToastStrategyPage) return <ToastStrategyPage />;
  if (isLilysPage) return <LilysDeckPage />;
  if (proposalMatch) return <DynamicProposalPage slug={proposalMatch[1]} />;
  return <PortfolioApp />;
}

export default App;
